// DEPENDENCIES
import React, { useMemo } from 'react';

// DEPENDENCIES
import { useFormikContext } from 'formik';
import { reduce } from 'lodash';

// GLOBAL VARIABLES
import { RETAIL_WHOLESALE } from 'codes';

// LOCAL VARIABLES
import { CUSTOMER_TYPES } from '../variables';

// GLOBAL COMPONENTS
import Form from 'core/form/Form';
import Card from 'parts/card/Card';

const CUSTOMER_TYPE_OPTIONS = reduce(CUSTOMER_TYPES, (result, type) => {
  result.push({
    label: type.label,
    value: type.id
  })
  return result;
}, [])

// MAIN COMPONENT
const CustomerInfoForm = () => {

  // FORMIK
  const { values } = useFormikContext() || {};

  // MEMOS
  const {
    customer_is_employee,
    customer_type_id,
    sale_type_category_id
  } = useMemo(
    () => values || {},
    [values]
  )
  const customerIsEmployee = useMemo(
    () => String(customer_is_employee) === 'true',
    [customer_is_employee]
  )
  const isOrganization = useMemo(
    () => String(customer_type_id) === String(CUSTOMER_TYPES.organization.id),
    [customer_type_id]
  )
  const isRetail = useMemo(
    () => parseInt(sale_type_category_id) === RETAIL_WHOLESALE.retail.numeric,
    [sale_type_category_id]
  );

  // RENDER
  return (
    <Form.Body>
      <Form.Checklist name="customer_type_id" type="radio" label="Customer Type" options={CUSTOMER_TYPE_OPTIONS} required />
      <Form.Control name="customer_first_name" label={isOrganization ? 'Organization' : 'First Name'} type="name" required />
      {!isOrganization && <Form.Control name="customer_last_name" label="Last Name" type="name" required />}
      <Form.Control name="customer_email_address" label="Email Address" type="email" required={isRetail} />
      <Form.Control name="mobile_phone_number" label="Mobile Phone" schema="tel" required={isRetail} />
      <Form.Control name="customer2_first_name" label="Customer 2 First Name" type="name" />
      <Form.Control name="customer2_last_name" label="Customer 2 Last Name" type="name" />
      <Form.Control name="customer2_email_address" label="Customer 2 Email Address" type="email" />
      <Form.YesNo
        name="customer_is_employee"
        label="Is this Customer/Buyer an Employee"
        numeric={false}
      />
      {customerIsEmployee && <>
        <Form.Control name="employee_employer_name" label="Where Does the Employee Work?" required />
        <Form.Control name="employee_work_id" label="Employee's Work ID#" required />
      </>}
    </Form.Body>
  )
}

// EXPORT
export default function CustomerInfo(props) {
  return <Card title="Customer Info" body={<CustomerInfoForm {...props} />} />;
}
